import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=5523da50"
import script from "./SettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports